export const EmDash = () => <>—</>
export const EnDash = () => <>–</>

export const FormattedEmDash = (
  <span className="text-bz-text-tertiary">
    <EmDash />
  </span>
)
